module.exports = __webpack_public_path__ + "static/media/Bodywork-red.97681705.svg";